import styled from "styled-components"
import { OriginalSelect } from ".."

export const SelectWrapper = styled.div`

`

export const SelectStyled = styled(OriginalSelect)`
 
`